export default __webpack_public_path__ + "static/media/work.b441c02b.png";